import { createSlice } from "@reduxjs/toolkit";
import {
  fetchScreens,
  fetchLocalization,
  createLocalization,
  updateLocalization,
  deleteLocalization,
  fetchLocalizationTableColumnNames,
  updateUserPreference,
  fetchLogs,
  fetchScreenTableColumnNames,
  createScreen,
  updateScreen,
  deleteScreen,
} from "./thunk";
import { toast } from "react-toastify";

const initialState = {
  preferences: {},
  screens: [],
  localization: [],
  tableColumnNames: [],
  ScreenTableColumnNames: [],
  loading: false,
  screenLoading: false,
  error: null,
};

const localizationSlice = createSlice({
  name: "localization",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch Screens API
      .addCase(fetchScreens.pending, (state) => {
        state.screenLoading = true;
        state.error = null;
      })
      .addCase(fetchScreens.fulfilled, (state, action) => {
        state.screenLoading = false;
        state.screens = action.payload;
      })
      .addCase(fetchScreens.rejected, (state, action) => {
        state.screenLoading = false;
        state.error = action.payload;
      })

      // Fetch Localization API
      .addCase(fetchLocalization.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLocalization.fulfilled, (state, action) => {
        state.loading = false;
        state.localization = action.payload;
      })
      .addCase(fetchLocalization.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add Localization API
      .addCase(createLocalization.pending, (state) => {
        // state.loading = true;
        state.error = null;
      })
      .addCase(createLocalization.fulfilled, (state, action) => {
        // state.loading = false;
        state.localization = [...action.payload.data, ...state.localization];
      })
      .addCase(createLocalization.rejected, (state, action) => {
        // state.loading = false;
        state.error = action.payload;
      })

      // Update Localization API
      .addCase(updateLocalization.pending, (state) => {
        // state.loading = true;
        state.error = null;
      })
      .addCase(updateLocalization.fulfilled, (state, action) => {
        const index = state.localization.findIndex(
          (item) => item.ID === action.payload[0].ID
        );
      
        if (index !== -1) {
          state.localization[index] = action.payload[0]; 
        } else {
          console.warn("Item to update not found in localization array.");
        }
      })      
      .addCase(updateLocalization.rejected, (state, action) => {
        // state.loading = false;
        state.error = action.payload;
      })

      // Delete Localization API
      .addCase(deleteLocalization.pending, (state) => {
        // state.loading = true;
        state.error = null;
      })
      .addCase(deleteLocalization.fulfilled, (state, action) => {
        // Extract IDs from the payload
        const deletedIds = action.payload.map((item) => item.ID);

        // Filter out the deleted items
        state.localization = state.localization.filter(
          (item) => !deletedIds.includes(item.ID)
        );

      })

      .addCase(deleteLocalization.rejected, (state, action) => {
        // state.loading = false;
        state.error = action.payload;
      })

      // Fetch Localization Table Column Names API
      .addCase(fetchLocalizationTableColumnNames.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLocalizationTableColumnNames.fulfilled, (state, action) => {
        state.loading = false;
        state.tableColumnNames = action.payload;
      })
      .addCase(fetchLocalizationTableColumnNames.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch Screen Table Column Names API
      .addCase(fetchScreenTableColumnNames.pending, (state) => {
        state.screenLoading = true;
        state.error = null;
      })
      .addCase(fetchScreenTableColumnNames.fulfilled, (state, action) => {
        state.screenLoading = false;
        state.ScreenTableColumnNames = action.payload;
      })
      .addCase(fetchScreenTableColumnNames.rejected, (state, action) => {
        state.screenLoading = false;
        state.error = action.payload;
      })

      // Update Preferences API
      .addCase(updateUserPreference.pending, (state) => {
        // state.loading = true;
        state.error = null;
      })
      .addCase(updateUserPreference.fulfilled, (state, action) => {
        // state.loading = false;
        state.preferences = action.payload;
      })
      .addCase(updateUserPreference.rejected, (state, action) => {
        // state.loading = false;
        state.error = action.payload;
      })

      // Add Screen API
      .addCase(createScreen.pending, (state) => {
        // state.loading = true;
        state.error = null;
      })
      .addCase(createScreen.fulfilled, (state, action) => {
        // state.loading = false;
      
        const screens = Array.isArray(action.payload.data)
          ? action.payload.data
          : [action.payload.data]; // Wrap it as array if it's a single object
      
        state.screens = [...screens, ...state.screens];
      
        // toast.success(action.payload.message);
      })      
      .addCase(createScreen.rejected, (state, action) => {
        // state.loading = false;
        state.error = action.payload;
      })

      // Update Screen API
      .addCase(updateScreen.pending, (state) => {
        // state.loading = true;
        state.error = null;
      })
      .addCase(updateScreen.fulfilled, (state, action) => {
        // state.loading = false;
        const index = state.screens.findIndex(
          (item) => item.ID === action.payload.ID
        );
        
        if (index !== -1) {
          state.screens[index] = action.payload;
        }
      })
      .addCase(updateScreen.rejected, (state, action) => {
        // state.loading = false;
        state.error = action.payload;
      })

      // Delete screen API
      .addCase(deleteScreen.pending, (state) => {
        // state.loading = true;
        state.error = null;
      })
      .addCase(deleteScreen.fulfilled, (state, action) => {
        // Extract IDs from the payload
        const deletedIds = action.payload.map((item) => item.ID);

        // Filter out the deleted items
        state.screens = state.screens.filter(
          (item) => !deletedIds.includes(item.ID)
        );

      })

      .addCase(deleteScreen.rejected, (state, action) => {
        // state.loading = false;
        state.error = action.payload;
      });
  },
});

export default localizationSlice.reducer;
